module.exports = __webpack_public_path__ + "img/frente-dni-viejo.dbd9a6ff.png";